class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.setHeaderCartIconAccessibility();
    this.onUpsellClick = this.onUpsellClick.bind(this);
    this.onUpsellDocClick = this.onUpsellDocClick.bind(this);
    this.addEventListener('click', this.onUpsellClick);
    document.addEventListener('click', this.onUpsellDocClick);

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));

    requestAnimationFrame(() => this.initUpsellSlider());
  }

  setHeaderCartIconAccessibility() {
    if (CartDrawer.cartIconBound) return;
    CartDrawer.cartIconBound = true;

    const openFromIcon = (event) => {
      const cartLink = event.target.closest('#cart-icon-bubble');
      if (!cartLink) return;

      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      event.preventDefault();
      drawer.open(cartLink);
    };

    document.addEventListener('click', openFromIcon);
    document.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() !== 'SPACE' && event.code.toUpperCase() !== 'ENTER') return;
      const cartLink = event.target.closest('#cart-icon-bubble');
      if (!cartLink) return;
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      event.preventDefault();
      drawer.open(cartLink);
    });

    document.querySelectorAll('#cart-icon-bubble').forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
    });
  }

  getUpsellListWrap(list) {
    return list?._upsellWrap || list?.closest('.cart-drawer-upsell__size-wrap') || null;
  }

  onUpsellDocClick(event) {
    const sizeOption = event.target.closest('.cart-drawer-upsell__size-option[data-variant-id]');
    if (sizeOption) {
      const list = sizeOption.closest('.cart-drawer-upsell__sizes');
      if (list && this.getUpsellListWrap(list) && this.contains(this.getUpsellListWrap(list))) {
        event.preventDefault();
        this.selectUpsellSize(sizeOption);
        return;
      }
    }

    const openList = document.querySelector('.cart-drawer-upsell__sizes.is-open');
    if (!openList || !this.getUpsellListWrap(openList) || !this.contains(this.getUpsellListWrap(openList))) return;
    if (event.target.closest('.cart-drawer-upsell__sizes.is-open')) return;
    if (event.target.closest('.cart-drawer-upsell__size-toggle')) return;
    if (event.target.closest('.cart-drawer-upsell__selected-size')) return;
    this.closeAllUpsellSizes();
  }

  onUpsellClick(event) {
    const sizeToggle = event.target.closest('.cart-drawer-upsell__size-toggle');
    if (sizeToggle && this.contains(sizeToggle)) {
      event.preventDefault();
      this.toggleUpsellSizes(sizeToggle);
      return;
    }

    const selectedSize = event.target.closest('.cart-drawer-upsell__selected-size');
    if (selectedSize && this.contains(selectedSize)) {
      event.preventDefault();
      const wrap = selectedSize.closest('.cart-drawer-upsell__size-wrap');
      let sizeList = wrap && wrap.querySelector('.cart-drawer-upsell__sizes');
      if (!sizeList && wrap) {
        sizeList = Array.from(document.querySelectorAll('.cart-drawer-upsell__sizes')).find(
          (el) => el._upsellWrap === wrap
        );
      }
      const addBtn = wrap && wrap.querySelector('.cart-drawer-upsell__add-to-cart');
      if (!sizeList) return;
      const willOpen = sizeList.hasAttribute('hidden') || !sizeList.classList.contains('is-open');
      this.closeAllUpsellSizes();
      if (willOpen) {
        wrap.classList.add('is-open');
        this.openUpsellSizes(addBtn || selectedSize, sizeList, wrap);
      }
      return;
    }

    const button = event.target.closest(
      '.cart-drawer-upsell__add-to-cart[data-variant-id], .cart-drawer-upsell__add[data-variant-id]:not(.cart-drawer-upsell__size-toggle)'
    );
    if (!button || !this.contains(button) || button.hasAttribute('hidden')) return;
    if (!button.getAttribute('data-variant-id')) return;
    this.onUpsellAdd(event, button);
  }

  selectUpsellSize(sizeOption) {
    const list = sizeOption.closest('.cart-drawer-upsell__sizes');
    const wrap = this.getUpsellListWrap(list);
    if (!wrap) return;

    const variantId = sizeOption.getAttribute('data-variant-id');
    const variantTitle = sizeOption.getAttribute('data-variant-title') || sizeOption.textContent.trim();
    const selectedLabel = wrap.querySelector('.cart-drawer-upsell__selected-size');
    const toggle = wrap.querySelector('.cart-drawer-upsell__size-toggle');
    const addBtn = wrap.querySelector('.cart-drawer-upsell__add-to-cart');

    if (selectedLabel) {
      selectedLabel.textContent = `Size: ${variantTitle}`;
      selectedLabel.hidden = false;
    }
    if (toggle) {
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }
    if (addBtn) {
      addBtn.setAttribute('data-variant-id', variantId);
      addBtn.removeAttribute('hidden');
    }

    this.closeAllUpsellSizes();
  }

  toggleUpsellSizes(toggle) {
    const wrap = toggle.closest('.cart-drawer-upsell__size-wrap');
    let list = wrap && wrap.querySelector('.cart-drawer-upsell__sizes');
    if (!list && wrap) {
      list = Array.from(document.querySelectorAll('.cart-drawer-upsell__sizes')).find(
        (el) => el._upsellWrap === wrap
      );
    }
    if (!list) return;

    const willOpen = list.hasAttribute('hidden') || !list.classList.contains('is-open');
    this.closeAllUpsellSizes();

    if (willOpen) {
      toggle.setAttribute('aria-expanded', 'true');
      wrap.classList.add('is-open');
      this.openUpsellSizes(toggle, list, wrap);
    }
  }

  openUpsellSizes(anchor, list, wrap) {
    list._upsellWrap = wrap || list._upsellWrap || list.closest('.cart-drawer-upsell__size-wrap');

    if (!list._upsellSlot) {
      const slot = document.createElement('span');
      slot.className = 'cart-drawer-upsell__sizes-slot';
      slot.hidden = true;
      list.parentNode.insertBefore(slot, list);
      list._upsellSlot = slot;
    }

    document.body.appendChild(list);
    list.classList.add('is-open');
    list.removeAttribute('hidden');
    this.positionUpsellSizes(anchor, list);
    this.bindUpsellSizesDismiss();
  }

  positionUpsellSizes(anchor, list) {
    const rect = anchor.getBoundingClientRect();
    const gap = 4;
    const maxH = 160;
    const spaceAbove = rect.top;
    const spaceBelow = window.innerHeight - rect.bottom;
    const openUp = spaceAbove >= spaceBelow;

    list.style.position = 'fixed';
    list.style.left = `${Math.round(rect.left)}px`;
    list.style.width = `${Math.max(Math.round(rect.width), 80)}px`;
    list.style.zIndex = '100000';
    list.style.margin = '0';

    if (openUp) {
      list.style.top = 'auto';
      list.style.bottom = `${Math.round(window.innerHeight - rect.top + gap)}px`;
      list.style.maxHeight = `${Math.min(maxH, Math.max(80, spaceAbove - gap))}px`;
    } else {
      list.style.bottom = 'auto';
      list.style.top = `${Math.round(rect.bottom + gap)}px`;
      list.style.maxHeight = `${Math.min(maxH, Math.max(80, spaceBelow - gap))}px`;
    }
  }

  clearUpsellSizesPosition(list) {
    list.style.position = '';
    list.style.left = '';
    list.style.width = '';
    list.style.top = '';
    list.style.bottom = '';
    list.style.zIndex = '';
    list.style.margin = '';
    list.style.maxHeight = '';
  }

  restoreUpsellSizes(list) {
    list.setAttribute('hidden', '');
    list.classList.remove('is-open');
    this.clearUpsellSizesPosition(list);
    if (list._upsellSlot && list._upsellSlot.parentNode) {
      list._upsellSlot.parentNode.insertBefore(list, list._upsellSlot);
    }
  }

  bindUpsellSizesDismiss() {
    if (this._upsellSizesBound) return;
    this._upsellSizesBound = true;

    this._onUpsellSizesDismiss = () => this.closeAllUpsellSizes();
    window.addEventListener('resize', this._onUpsellSizesDismiss);
    this.querySelector('.cart-drawer-upsell__track')?.addEventListener('scroll', this._onUpsellSizesDismiss);
    this.querySelector('.drawer__inner')?.addEventListener('scroll', this._onUpsellSizesDismiss);
  }

  closeAllUpsellSizes() {
    document.querySelectorAll('.cart-drawer-upsell__sizes').forEach((list) => {
      const wrap = this.getUpsellListWrap(list);
      if (wrap && this.contains(wrap)) {
        this.restoreUpsellSizes(list);
      } else if (this.contains(list)) {
        this.restoreUpsellSizes(list);
      }
    });

    this.querySelectorAll('.cart-drawer-upsell__size-toggle').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });
    this.querySelectorAll('.cart-drawer-upsell__size-wrap.is-open').forEach((wrap) => {
      wrap.classList.remove('is-open');
    });
  }

  onUpsellAdd(event, button) {
    button = button || event.currentTarget;
    const variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.getAttribute('aria-disabled') === 'true') return;

    button.setAttribute('aria-disabled', 'true');

    const body = JSON.stringify({
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.description || response.message);
          return;
        }
        this.classList.remove('is-empty');
        this.renderContents(response);
      })
      .catch((error) => console.error(error))
      .finally(() => button.removeAttribute('aria-disabled'));
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      this.initUpsellSlider();
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.stopUpsellSlider();
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  stopUpsellSlider() {
    if (this._upsellTimer) {
      clearInterval(this._upsellTimer);
      this._upsellTimer = null;
    }
    if (this._upsellTrack && this._upsellOnScroll) {
      this._upsellTrack.removeEventListener('scroll', this._upsellOnScroll);
    }
    if (this._upsellRoot) {
      this._upsellRoot.removeEventListener('pointerenter', this._upsellPause);
      this._upsellRoot.removeEventListener('pointerleave', this._upsellResume);
      this._upsellRoot.removeEventListener('touchstart', this._upsellPause);
    }
    this._upsellTrack = null;
    this._upsellRoot = null;
  }

  initUpsellSlider() {
    this.stopUpsellSlider();

    const root = this.querySelector('.cart-drawer-upsell');
    const track = root && root.querySelector('.cart-drawer-upsell__track');
    if (!root || !track) return;

    const items = Array.from(track.querySelectorAll('.cart-drawer-upsell__item'));
    if (items.length < 2) return;

    const autoplay = root.dataset.autoplay === 'true';
    const speed = Number(root.dataset.autoplaySpeed || 4000);
    const showDots = root.dataset.mobileDots === 'true';
    const dotsEl = root.querySelector('.cart-drawer-upsell__dots');

    this._upsellRoot = root;
    this._upsellTrack = track;

    const getStep = () => {
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return (items[0]?.offsetWidth || track.clientWidth) + gap;
    };

    const renderDots = () => {
      if (!showDots || !dotsEl) return;
      const maxScroll = track.scrollWidth - track.clientWidth;
      const ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      const active = ratio < 1 / 3 ? 0 : ratio < 2 / 3 ? 1 : 2;
      dotsEl.innerHTML = [0, 1, 2]
        .map(
          (i) =>
            `<button type="button" class="cart-drawer-upsell__dot${
              i === active ? ' is-active' : ''
            }" data-dot-index="${i}" aria-label="Upsell slide ${i + 1}"></button>`
        )
        .join('');
    };

    this._upsellOnScroll = () => {
      window.requestAnimationFrame(renderDots);
    };
    track.addEventListener('scroll', this._upsellOnScroll, { passive: true });
    renderDots();

    if (showDots && dotsEl) {
      dotsEl.onclick = (event) => {
        const btn = event.target.closest('[data-dot-index]');
        if (!btn) return;
        const dotIndex = Number(btn.dataset.dotIndex);
        const maxScroll = track.scrollWidth - track.clientWidth;
        const target =
          dotIndex === 0 ? 0 : dotIndex === 2 ? maxScroll : maxScroll / 2;
        track.scrollTo({ left: target, behavior: 'smooth' });
      };
    }

    const slideNext = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 1) return;
      const step = getStep();
      let next = track.scrollLeft + step;
      if (next >= maxScroll - 4) next = 0;
      track.scrollTo({ left: next, behavior: 'smooth' });
    };

    const startTimer = () => {
      if (!autoplay) return;
      if (this._upsellTimer) clearInterval(this._upsellTimer);
      this._upsellTimer = setInterval(slideNext, Math.max(2000, speed));
    };

    this._upsellPause = () => {
      if (this._upsellTimer) {
        clearInterval(this._upsellTimer);
        this._upsellTimer = null;
      }
    };
    this._upsellResume = () => startTimer();

    if (autoplay) {
      root.addEventListener('pointerenter', this._upsellPause);
      root.addEventListener('pointerleave', this._upsellResume);
      root.addEventListener('touchstart', this._upsellPause, { passive: true });
      startTimer();
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const html = parsedState.sections[section.id];
      if (!html) return;

      if (section.id === 'cart-icon-bubble') {
        const iconHtml = this.getSectionInnerHTML(html, section.selector);
        document.querySelectorAll('#cart-icon-bubble').forEach((el) => {
          el.innerHTML = iconHtml;
          el.setAttribute('role', 'button');
          el.setAttribute('aria-haspopup', 'dialog');
        });
        return;
      }

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(html, section.selector);
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
      this.initUpsellSlider();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
